import { SxProps, Theme } from '@mui/system';
import { css } from '@emotion/react';

export const cssToSx = (flattenCss: ReturnType<typeof css>): SxProps<Theme> => {
  const styleString = flattenCss.toString();
  const styleObject = styleString.split(';').reduce<Record<string, string>>((acc, style) => {
    const [key, value] = style.split(':').map((str) => str.trim());
    if (key && value) {
      acc[key] = value;
    }
    return acc;
  }, {});
  return styleObject;
};
